export default __webpack_public_path__ + "static/media/Resposta.e1cd0737.svg";